module.exports = __webpack_public_path__ + "5e077f2f25715cda2d32bba70f17582f.svg";